import { Verse } from "~/state/bible/types";

export const getVerseNumber = (verseId: string, bookId: string) => {
  return Number(verseId?.split(`${bookId}.`)[1]);
};

export const getVerseNumbers = (verses: Verse[], bookId: string) => {
  return verses.map(({ verseId }) => getVerseNumber(verseId, bookId));
};
